class Controller {
  constructor(Events, Lists) {
    "ngInject";

    this.isPricingConfEditable = false;
    this.RoundingOffList = Lists.all.roundingOffList;
    this.Events = Events;
  }

  togglePricingConfEditing() {
    this.isPricingConfEditable = !this.isPricingConfEditable;
  }
  updatePricingConf() {
    const scheduleUpdateArguments = {
      schedule: this.schedule,
      index: this.scheduleIndex,
    };
    // Send Pricing Parameters as function arguments for wherever it is used
    // If used in schedules send index as argument, updating pricing conf in schedules needs more arguments/;
    this.schedule
      ? this.Events.emit(this.updateMethod, scheduleUpdateArguments)
      : this.Events.emit(this.updateMethod, this.pricingParameters);
  }

  resetPricingConf() {
    const scheduleUpdateArguments = {
      schedule: this.schedule,
      index: this.scheduleIndex,
    };
    this.Events.emit(this.resetMethod, scheduleUpdateArguments);
  }

  resetPricingConfOnNewSchedules() {
    const scheduleUpdateArguments = {
      schedule: this.schedule,
      index: this.scheduleIndex,
    };
    this.togglePricingConfEditing();
    this.Events.emit(this.resetMethodNewSchedule, scheduleUpdateArguments);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/pricingConfiguration/pricingConfiguration.controller.js